export const countryToProviderIds = {
  // 'UPS', 'FedEx', 'DHL eCommerce', 'FirstMile', 'OnTrac', 'Globegistics', 'APC', 'Newgistics', 'GLS US'
  US: [3, 4, 6, 16, 14, 17, 21, 15, 122],
  // 'Canada Post','FedEx','UPS','Purolator Canada','Canpar','DHL Express Canada','DHL eCommerce','Nationex','Swyft'
  CA: [11, 4, 3, 30, 60, 24, 6, 2689, 134],
  // 'Sendle','UPS','Australia Post MyPost Business','Australia Post','StarTrack','CouriersPlease','Fastway AU','DHL Express Australia','FedEx','Toll Priority'
  AU: [33, 3, 111, 23, 43, 61, 92, 28, 4, 94],
  // 'NZ Post Domestic','NZ Post International','UPS','Fastway NZ','New Zealand Couriers','Post Haste','Now Couriers','Castle Parcels','FedEx','DHL Express'
  NZ: [108, 86, 3, 93, 2705, 2707, 2706, 2704, 4, 13],
  // 'Royal Mail','Evri','DPD','FedEx','Parcelforce','DHL Express UK','UPS','Seko Omni','Deutsche Post Cross Border'
  GB: [20, 54, 42, 4, 41, 29, 3, 63, 110],
  // 'Colissimo','Delivengo','Chronopost','UPS','DPD FR','DHL Express','FedEx'
  FR: [91, 123, 98, 3, 148, 13, 4],
  // 'UPS','Deutsche Post Cross Border','FedEx'
  DE: [3, 110, 4],
};
